import axios from "axios";
import axiosInstance from "../../../Utils/axios";
import { paginationQueryParams } from "../../../Utils/paginationParam";
let cancelToken;

const apiLogsURL = "api/v1/api-logs-app";

//obtaining the paginated data

//obtaining the paginated data
export const getApiLogs = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${apiLogsURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllApiLogs = () => axiosInstance.get(`${apiLogsURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageApiLogs = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${apiLogsURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

// get by id
export const getSpecificApiLogs = (id) => axiosInstance.get(`${apiLogsURL}/retrieve/${id}`);

//searching function
export const handleSearch = (search, rowsPerPage) =>
  axiosInstance.get(`${apiLogsURL}/list?offset=0&limit=${rowsPerPage}&search=${search}`);
